<template>
  <vx-card class="cardx">
    <vs-tabs v-model="stepIndex">
      <vs-tab
        v-for="(step, index) in steps"
        :key="step.key"
        :label="step.name"
        :class="[index === 0 ? `${step.key}-step` : null]"
        :uk-position-center-left="index !== 0 ? `${step.key}-step` : null"
      >
        <!-- search -->
        <div class="vx-row">
          <div class="vx-col w-full m-auto">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/5">
                <div class="mt-4">
                  <label class="vs-input--label">Keyword</label>
                  <vs-input
                    v-model="params.search"
                    name="search"
                    class="w-full"
                  />
                </div>
              </div>

              <div class="vx-col w-full md:w-1/5">
                <div class="mt-4">
                  <label class="vs-input--label">Follow up at</label>
                  <datepicker
                    v-model="params.date_follow_up"
                    name="date_follow_up"
                    :minimumView="'day'"
                    :maximumView="'month'"
                    :format="customFormatter"
                  />
                </div>
              </div>
              <div class="vx-col w-full md:w-1/5">
                <div class="mt-4">
                  <label class="vs-input--label">Date Start</label>
                  <datepicker
                    v-model="params.date_start"
                    name="date_start"
                    :minimumView="'day'"
                    :maximumView="'month'"
                    :disabledDates="disabledEndDates"
                    :format="customFormatter"
                  />
                </div>
              </div>

              <div class="vx-col w-full md:w-1/5">
                <div class="mt-4">
                  <label class="vs-input--label">Date End</label>
                  <datepicker
                    v-model="params.date_end"
                    name="date_end"
                    :minimumView="'day'"
                    :maximumView="'month'"
                    :disabledDates="disabledStartDates"
                    :format="customFormatter"
                  />
                </div>
              </div>

              <div class="vx-col w-full md:w-1/5">
                <div class="mt-10">
                  <vs-button @click.prevent="handleSearch()" class="mr-4"
                    >SEARCH</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- table -->
        <custom-vs-table
          ref="table"
          pagination
          stripe
          sst
          hoverFlat
          :data="step.tests.data"
          :max-items="step.tests.meta.pagination.per_page"
          :total="step.tests.meta.pagination.total"
          @change-page="handleChangePage"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between my-2"
          ></div>

          <template slot="thead">
            <vs-th class="thead">No</vs-th>
            <vs-th class="thead">Testing Date</vs-th>
            <vs-th class="thead" sort-key="name">Mother Name</vs-th>
            <vs-th class="thead" sort-key="baby_name">Child Name</vs-th>
            <vs-th class="thead">Contact Number</vs-th>
            <vs-th class="thead">Stool Types</vs-th>
            <vs-th class="thead">Gut Check</vs-th>
            <vs-th class="thead">Follow up</vs-th>
            <vs-th class="thead">Action</vs-th>
          </template>

          <template>
            <vs-tr v-for="(stoolTest, index) in step.tests.data" :key="index">
              <vs-td>
                {{ rowNo(index) }}
              </vs-td>
              <vs-td>
                <span>
                  {{ $helpers.dateFormat(stoolTest.created_at) }}
                </span>
              </vs-td>
              <vs-td :data="stoolTest.name">
                {{ stoolTest.name }}
              </vs-td>
              <vs-td :data="stoolTest.baby_name">
                {{ stoolTest.baby_name }}
              </vs-td>
              <vs-td>
                {{ stoolTest.contact }}
              </vs-td>
              <vs-td>
                {{ stoolTest.stool_consistency | capitalize }}
              </vs-td>
              <vs-td>
                <cell-renderer-gut-check :status="stoolTest.result_status" />
              </vs-td>
              <vs-td>
                <span>
                  {{ $helpers.dateFormat(stoolTest.follow_up_at) }}
                </span>
              </vs-td>
              <vs-td>
                <vs-button
                  class="float-left"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  :to="{
                    name: 'stool-questionnaire.edit',
                    params: {
                      id: stoolTest.id
                    }
                  }"
                />
                <!--<vs-button
                  class="float-left"
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click.prevent="remove(stoolTest.id)"/>-->
              </vs-td>
            </vs-tr>
          </template>
        </custom-vs-table>

        <vs-button
          class="mr-4"
          color="success"
          @click.prevent="handleExport('summary')"
          >EXPORT SUMMARY</vs-button
        >
        <vs-button
          class="mr-4"
          color="warning"
          @click.prevent="handleExport('complete')"
          >EXPORT COMPLETE</vs-button
        >
        <vs-button color="warning" @click.prevent="handleExport('contactable')"
          >EXPORT CONTACTABLE</vs-button
        >
      </vs-tab>
    </vs-tabs>

    <vs-progress
      indeterminate
      color="success"
      v-if="is_generating"
    ></vs-progress>
  </vx-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { default as listMixin } from '@/mixins/listMixin'
import CustomVsTable from '@/components/table/CustomVsTable'
import CellRendererGutCheck from '@/components/table/cell-renderer/GutCheck'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import helpers from '@/utils/helpers'
import FileSaver from 'file-saver'

import '@/laravelEcho'

export default {
  mixins: [listMixin],
  components: {
    CustomVsTable,
    CellRendererGutCheck,
    Datepicker
  },
  data: () => ({
    dateFormat: 'DD MMM YYYY',
    step: 'new',
    stepIndex: 0,
    filter: {
      step: 'new',
      date_follow_up: null,
      date_start: null,
      date_end: null,
      search: null
    },
    params: {
      step: 'new',
      date_follow_up: null,
      date_start: null,
      date_end: null,
      search: null
    },
    is_generating: false
  }),
  computed: {
    ...mapGetters('stoolQuestionnaire', ['steps', 'uuid']),
    ...mapGetters('data', [
      'stoolBabyAges',
      'stoolColors',
      'stoolConsistencies',
      'stoolFrequencies'
    ]),

    currentStep() {
      return this.steps[this.stepIndex]
    },
    disabledEndDates() {
      if (!this.lodash.isEmpty(this.params.date_end)) {
        return {
          from: moment(this.params.date_end).endOf('month').toDate()
        }
      }

      return {
        from: moment().toDate()
      }
    },
    disabledStartDates() {
      if (!this.lodash.isEmpty(this.params.date_start)) {
        return {
          to: moment(this.params.date_start).endOf('month').toDate()
        }
      }

      return {
        from: moment().toDate()
      }
    }
  },
  methods: {
    ...mapActions('stoolQuestionnaire', [
      'fetch',
      'reset',
      'generate',
      'download',
      'resetExport'
    ]),
    ...mapActions('data', [
      'fetchStoolBabyAges',
      'fetchStoolColors',
      'fetchStoolConsistencies',
      'fetchStoolFoodTypes',
      'fetchStoolFrequencies'
    ]),

    getStep(step) {
      return this.steps.find((item) => item.key === step)
    },
    async _fetch({ step, page } = {}) {
      this.locked = true

      if (!this.lodash.isUndefined(step)) {
        this.params.step = step
      }

      if (!this.lodash.isUndefined(page)) {
        this.params.page = page
      }

      await this.fetch({ ...this.lodash.get(this, 'params', {}) })

      this.locked = false
    },

    customFormatter(date) {
      return this.$moment(date).format(this.dateFormat)
    },

    handleFilter() {
      this.$router
        .push({
          query: helpers.removePropertyIsEmpty({
            date_follow_up: this.params.date_follow_up,
            date_start: this.params.date_start,
            date_end: this.params.date_end,
            search: this.params.search
          })
        })
        .catch(() => {})

      this.selected = []

      this.handleSearch()
    },

    async handleExport(report) {
      this.locked = true
      await this.generate({ report })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Request reports fail',
            iconPack: 'feather',
            icon: 'icon-error',
            color: 'danger'
          })
        })
        .finally(() => {
          this.locked = false
        })
    },

    async downloadResult(uuid) {
      this.locked = true

      await this.download({ uuid })
        .then((response) => {
          const disposition = this.lodash.get(
            response,
            'headers.content-disposition'
          )

          let fileName = 'export.xlsx'
          if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(disposition)
            if (matches !== null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '')
            }
          }

          FileSaver.saveAs(new Blob([response.data]), fileName)

          this.resetExport()

          this.$vs.notify({
            title: 'Success',
            text: 'Result has been generated',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Result unable to generate',
            iconPack: 'feather',
            icon: 'icon-error',
            color: 'danger'
          })
        })
        .finally(() => {
          this.locked = false
        })
    }
  },

  beforeMount() {
    if (this.$route.query.step) {
      const step = this.getStep(this.$route.query.step)
      this.stepIndex = this.lodash.findIndex(this.steps, { key: step.key })
      this.step = step.key
    }
    if (this.stoolBabyAges.length === 0) {
      this.fetchStoolBabyAges()
    }
    if (this.stoolColors.length === 0) {
      this.fetchStoolColors()
    }
    // if (this.stoolFoodTypes.length === 0) {
    //   this.fetchStoolFoodTypes()
    // }
    if (this.stoolFrequencies.length === 0) {
      this.fetchStoolFrequencies()
    }
    if (this.stoolConsistencies.length === 0) {
      this.fetchStoolConsistencies()
    }
  },
  async mounted() {
    const { key: step } = this.steps[this.stepIndex]

    this._fetch({ step })

    const self = this

    window.Echo.channel('stool-questionnaires')
      .listen('.generated', function (data) {
        setTimeout(function () {
          if (
            !self.lodash.isEmpty(self.uuid) &&
            self.lodash.get(data, 'uuid') === self.uuid
          ) {
            self.downloadResult(self.uuid)
          }
        }, 1000)
        // app.messages.push(JSON.stringify(data));
      })
      .listen('.exception', function (data) {
        if (
          !self.lodash.isEmpty(self.uuid) &&
          self.lodash.get(data, 'uuid') === self.uuid
        ) {
          self.resetExport()

          self.$vs.notify({
            title: 'Exception',
            text: self.lodash.get(data, 'message', 'Unable to generate'),
            iconPack: 'feather',
            icon: 'icon-error',
            color: 'danger'
          })
        }
      })
  },

  beforeDestroy() {
    window.Echo.leaveChannel('stool-questionnaires')
  },

  watch: {
    stepIndex(to) {
      this.step = this.steps[to].key

      this.$router.push({ query: { step: this.step } }).catch(() => {})

      this._fetch({ step: this.step, page: 1 })
    },
    step(to) {
      this.params.step = to
    },
    'filter.date_follow_up'(to) {
      this.params.date_follow_up = this.lodash.get(to, 'value')

      this.handleFilter()
    },
    'filter.date_start'(to) {
      this.params.date_start = this.lodash.get(to, 'value')

      this.handleFilter()
    },
    'filter.date_end'(to) {
      this.params.date_end = this.lodash.get(to, 'value')

      this.handleFilter()
    },
    'filter.search'(to) {
      this.params.search = this.lodash.get(to, 'value')

      this.handleFilter()
    },
    uuid(to) {
      this.is_generating = !this.lodash.isEmpty(to)
    }
  }
}
</script>

<style lang="scss">
.cardx {
  margin-bottom: 20px;
}
.cardx .vx-card__body,
.cardx .vx-card__body .con-vs-tabs,
.cardx .vx-card__body .con-vs-tabs .con-slot-tabs {
  overflow: visible !important;
}
</style>
